<template>
  <div>
    <div class="text-right bg-white pr-4 pt-2"><router-link to="/login"><i class="fa fa-sign-in pr-2"></i>Iniciar sesión</router-link></div>
    <div class="app flex-row align-items-center bg-white">

      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="12">
            <b-card-group>
              
              <b-card no-body class="text-white" style="border: none;">
                <b-card-body class="text-center">
                  <div>
                    <img src="img/logo.png" class="col-md-12">
                  </div>
                </b-card-body>
              </b-card>

              <b-card no-body md="12" style="border: none;">
                <b-card-body class="p-4">
                  <b-form @submit.prevent="forget">
                    <h4 class="mb-5 text-center">Olvidé mi contraseña</h4>

                    <b-input-group class="px-5 pb-3">
                      <b-form-input type="email" class="form-control" placeholder="Introduzca su email" autocomplete="username email" v-model="user.email"/>
                    </b-input-group>

                    <b-row class="justify-content-center pt-2">
                        <b-button type="submit" variant="primary" class="px-5 btn btn-pill" :disabled="!user.email">Recordar</b-button>
                    </b-row>
                  </b-form>
                </b-card-body>
              </b-card>

            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
  
</template>

<script>
import VueNotifications from 'vue-notifications';

export default {
    name: 'Forget',
    data: ()=> ({
        user:{
            email: "",
        }
    }),
    mounted(){
        
    },
    methods:{
        forget(){
            let self = this;
            axios.post('/login/reset', this.user)
            .then(function (response) {
              self.showSuccessMsg();
              self.$router.push({name: 'login'});
            })
            .catch(function (error) {
              //Completar con información reportada por el backend
              self.showErrorMsg();
              console.log(error);
            });
        }

    },
    notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Solicitud correcta',
        message: 'Pronto recibirá un correo con instrucciones'
      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Solicitud denegada',
        message: 'El correo facilitado es incorrecto'
      }
    }
}
</script>
<style scoped>
input {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid lightgrey;
}
</style>
